import { render } from "./DsAttendanceHistoryCardSkeleton.vue?vue&type=template&id=1ba33c8c"
const script = {}

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__